import * as ambassadorWixLocaldeliverySpiV1Tpa from './localdelivery-spi-v1-tpa-local-delivery-spi.http.js';
import * as ambassadorWixLocaldeliverySpiV1TpaTypes from './localdelivery-spi-v1-tpa-local-delivery-spi.types.js';
import * as ambassadorWixLocaldeliverySpiV1TpaUniversalTypes from './localdelivery-spi-v1-tpa-local-delivery-spi.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function listAccountIds(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixLocaldeliverySpiV1TpaUniversalTypes.ListAccountIdsRequest,
  ambassadorWixLocaldeliverySpiV1TpaTypes.ListAccountIdsRequest,
  ambassadorWixLocaldeliverySpiV1TpaUniversalTypes.ListAccountIdsResponse,
  ambassadorWixLocaldeliverySpiV1TpaTypes.ListAccountIdsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixLocaldeliverySpiV1Tpa.listAccountIds(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/account-ids',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function businessStatus(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixLocaldeliverySpiV1TpaUniversalTypes.BusinessStatusRequest,
  ambassadorWixLocaldeliverySpiV1TpaTypes.BusinessStatusRequest,
  ambassadorWixLocaldeliverySpiV1TpaUniversalTypes.BusinessStatusResponse,
  ambassadorWixLocaldeliverySpiV1TpaTypes.BusinessStatusResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixLocaldeliverySpiV1Tpa.businessStatus(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/business-status',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function estimateDelivery(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixLocaldeliverySpiV1TpaUniversalTypes.EstimateDeliveryRequest,
  ambassadorWixLocaldeliverySpiV1TpaTypes.EstimateDeliveryRequest,
  ambassadorWixLocaldeliverySpiV1TpaUniversalTypes.EstimateDeliveryResponse,
  ambassadorWixLocaldeliverySpiV1TpaTypes.EstimateDeliveryResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixLocaldeliverySpiV1Tpa.estimateDelivery(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/estimate-delivery',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function createDelivery(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixLocaldeliverySpiV1TpaUniversalTypes.CreateDeliveryRequest,
  ambassadorWixLocaldeliverySpiV1TpaTypes.CreateDeliveryRequest,
  ambassadorWixLocaldeliverySpiV1TpaUniversalTypes.CreateDeliveryResponse,
  ambassadorWixLocaldeliverySpiV1TpaTypes.CreateDeliveryResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixLocaldeliverySpiV1Tpa.createDelivery(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/create-delivery',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  Tpa as TpaOriginal,
  ListAccountIdsRequest as ListAccountIdsRequestOriginal,
  ListAccountIdsResponse as ListAccountIdsResponseOriginal,
  BusinessStatusRequest as BusinessStatusRequestOriginal,
  BusinessStatusResponse as BusinessStatusResponseOriginal,
  BusinessStatus as BusinessStatusOriginal,
  BusinessStatusWithLiterals as BusinessStatusWithLiteralsOriginal,
  EstimateDeliveryRequest as EstimateDeliveryRequestOriginal,
  EstimateDeliveryRequestDispatchTimeOneOf as EstimateDeliveryRequestDispatchTimeOneOfOriginal,
  Address as AddressOriginal,
  StreetAddress as StreetAddressOriginal,
  AddressLocation as AddressLocationOriginal,
  Money as MoneyOriginal,
  EstimateDeliveryResponse as EstimateDeliveryResponseOriginal,
  CreateDeliveryRequest as CreateDeliveryRequestOriginal,
  CreateDeliveryRequestDispatchTimeOneOf as CreateDeliveryRequestDispatchTimeOneOfOriginal,
  Customer as CustomerOriginal,
  CreateDeliveryResponse as CreateDeliveryResponseOriginal,
  EstimateDeliveryApplicationErrors as EstimateDeliveryApplicationErrorsOriginal,
  CreateDeliveryApplicationErrors as CreateDeliveryApplicationErrorsOriginal,
} from './localdelivery-spi-v1-tpa-local-delivery-spi.types.js';
